import { Container, Col, Row, BreakPoint } from 'components/atoms/Grid';
import NewsList from 'containers/NewsList';
import { useQuery } from '@apollo/client';
import { gql } from 'apollo-boost';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { IsMobile } from 'helpers/isMobile';
import styled, { css } from 'styled-components';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Colors from 'components/tokens/Colors';
import { Loading } from 'react-loading-dot';
import { LoaderDots } from 'containers/NewsListing';
import NotFoundListing from 'pages/NotFoundListing';
import { Storyblok } from 'index';

const today = new Date().toISOString();

const query = gql`
    query ($perPage: Int, $tag: String, $page: Int) {
        EducationalarticleItems(with_tag: $tag, page: $page, per_page: $perPage, sort_by: "first_published_at:desc", first_published_at_lt:"${today}") {
            total
            items {
                first_published_at
                full_slug
                uuid
                name

                content {
                    hat
                    custom_hat
                    resume
                    featured_image {
                        alt
                        filename
                    }
                    authors {
                        fullSlug
                        name
                        content
                    }
                    schedule
                }
            }
        }
    }
`;

const queryWithFilter = gql`
    query ($page: Int, $perPage: Int, $hat: String) {
        EducationalarticleItems(
            page: $page
            per_page: $perPage
            sort_by: "first_published_at:desc"
            filter_query_v2: { hat: { in: $hat } }
            first_published_at_lt:"${today}") {
            total
            items {
                first_published_at
                full_slug
                uuid
                name

                content {
                    hat
                    custom_hat
                    resume
                    featured_image {
                        alt
                        filename
                    }
                    authors {
                        fullSlug
                        name
                        content
                    }
                    schedule
                }
            }
        }
    }
`;

const isHat = hat => {
    if (hat === 'na mochila' || hat === 'abre aspas' || hat === 'artigos' || hat === 'achado') {
        return true;
    }

    return false;
};

function EducationArticlesListing() {
    const [articles, setArticles] = useState([]);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [newContent, setNewContent] = useState(false);
    const [lastPageAdded, setLastPageAdded] = useState(0);
    const [allTags, setAllTags] = useState([]);
    const perPage = 30;
    const { slug } = useParams();

    const capitalize = str => {
        if (typeof str !== 'string') return '';
        return str.charAt(0).toUpperCase() + str.substr(1);
    };

    const firstOptionTerm = slug === 'todas' ? '' : slug.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const secondOptionTerm = slug.replace(/[-]+/g, ' ');
    const allContent = slug === 'todas' ? true : false;

    const { loading, error, data, refetch } = useQuery(
        isHat(slug) ? queryWithFilter : query,
        isHat(slug)
            ? {
                  variables: {
                      page: currentPage,
                      perPage,
                      hat: isHat(slug) ? slug : ''
                  }
              }
            : {
                  variables: {
                      page: currentPage,
                      tag: allContent
                          ? ''
                          : `${slug},${firstOptionTerm},${secondOptionTerm},${capitalize(slug)},${capitalize(
                                secondOptionTerm
                            )}`,
                      perPage
                  }
              }
    );

    useEffect(() => {
        let newValue = [];
        if (!loading) {
          newValue = data?.EducationalarticleItems?.items.toSorted((a, b) => {
            let newA = a.content.schedule ? new Date(a.content.schedule.replace(" ", "T") + ":00Z") : new Date(a.first_published_at)
            let newB = b.content.schedule ? new Date(b.content.schedule.replace(" ", "T") + ":00Z") : new Date(b.first_published_at)
            return newB - newA
          });
        }

        if (data) {
          setNewContent(true)
        } else if (error) {
          setNewContent(true)
          setLastPageAdded(currentPage - 1);
          // Decrement page NewsList has changed
          setCurrentPage(Math.max (0, currentPage - 1))
          return
        }

        if (currentPage === lastPageAdded) {
          return
        }

        setArticles(prevNews => [...prevNews, ...newValue]);
        setTotal(data?.EducationalarticleItems?.total);
    }, [data, loading, error]);

    const isMobile = IsMobile();

    const textResults = articles
        ? firstOptionTerm
            ? `Exibindo ${articles?.length} de ${total} resultados de`
            : `Exibindo ${articles?.length} de ${total} conteúdos de Educação`
        : '';

    if (error) return console.log(`Ops, something went wrong! \n ${error}`);

    if (!loading && total <= 0) {
        Storyblok.get('cdn/tags/')
            .then(response => {
                setAllTags(response.data.tags);
            })
            .catch(error => {
                console.log(error);
            });

        const removeAccents = str => {
            return str
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[-]+/g, ' ');
        };

        allTags.map(tag => {
            if (removeAccents(tag.name) === removeAccents(slug)) {
                return refetch({ tag: tag.name });
            }

            return <NotFoundListing />;
        });
    }

    return (
      <>
        <Container px="1.5 4">
            <Row justifyContent="center">
                <Col size="12">
                    {articles?.length > 0 ? (
                        <NewsList
                            content={articles}
                            text={textResults}
                            total={total}
                            highlightedText={slug === 'todas' ? null : capitalize(secondOptionTerm)}
                            onMoreNews={setCurrentPage}
                            currentPage={currentPage}
                            newContent={newContent}
                            onNewContent={setNewContent}
                        />
                    ) : (
                        <SkeletonContainer>
                            <div className="text">
                                <Skeleton height={isMobile ? '40px' : '23px'} />
                            </div>
                            <div className="wrapper">
                                <div className="left-col">
                                    <Skeleton height={isMobile ? '160px' : '23px'} />
                                </div>
                                {!isMobile && (
                                    <>
                                        <div className="right-col">
                                            <Skeleton height="22px" />
                                            <Skeleton height="61px" />
                                            <Skeleton height="44px" />
                                            <Skeleton height="21.5px" />
                                        </div>
                                        <div className="picture">
                                            <Skeleton height="160px" width={'264px'} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </SkeletonContainer>
                    )}
                </Col>
            </Row>
        </Container>
        <LoaderDots>
          {loading && (
            <Loading background={Colors.primary} />
          )}
        </LoaderDots>
      </>
    );
}

const SkeletonContainer = styled.div`
    width: 100%;
    margin-top: 7rem;
    margin-bottom: 4rem;

    ${BreakPoint(
        'sm',
        css`
            .text {
                width: 415px;
                margin-bottom: 2rem;
            }

            .left-col {
                width: 142px;
                margin-right: 3rem;
            }
        `
    )}

    .wrapper {
        display: flex;
    }

    .text {
        margin-bottom: 7rem;
    }

    .right-col {
        flex: 1;
        margin-right: 2rem;
    }

    @media (max-width: 768px) {
        .left-col {
            width: 100%;
        }
    }
`;

export default EducationArticlesListing;
